import { atomFamily } from "jotai/utils";

import { Session } from "types/Session";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

// This atom stores the session object fetched from the server on landing/refresh
const sessionServerSessionAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<Session | null>(`session-${sessionId}`, null)
);

export const serverSessionAtom = createDerivedSessionAtom<Session | null>(sessionServerSessionAtom);
